module.exports = __webpack_public_path__ + "img/shutters.6ecd7d68.svg";